














































































































































































import { Component, Vue } from "vue-property-decorator";
import QErrors from "@/common/qErrors.vue";
import StepCheckList from "@/components/contract-moving/step/stepCheckList.vue";
import ContractMoveOutHistory from "@/components/contract-moving/contractMoveOutHistory.vue";

@Component({
  name: "StepCorrectCheckList",
  components: {
    StepCheckList,
    QErrors,
    ContractMoveOutHistory,
  },
})
export default class StepCorrectCheckList extends Vue {
  get contractMoveOutId() {
    return this.$router.currentRoute.params.id;
  }
}
